import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../../assets/styles/smu-carousel.scss";
import { IconEdit } from "../../icons/Icon";
import { COLOR_PRIMARY } from "../../constants/colors";

const SmuCarousel = ({ isEdit, onEdit, banners }) => {
  return (
    <div className="smu-carousel">
      {Boolean(isEdit) && (
        <button type="button" className="carousel-edit shadow" onClick={onEdit}>
          <IconEdit color={COLOR_PRIMARY} />
        </button>
      )}
      <Carousel
        autoPlay={true}
        infiniteLoop={true}
        showArrows={false}
        showThumbs={false}
        showStatus={false}
        interval={5000}
      >
        {banners.map((banner) => <img key={banner.id} src={banner.url} alt="CAROUSEL" />)}
      </Carousel>
    </div>
  );
};

export default SmuCarousel;
